import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { person } from 'global/Models/userModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { setUserPerson } from 'redux/reducer/user/userReducer';
import { AppDispatch } from 'redux/store';

export const getUserPersonFullInfo = (id: number) => async (dispatch: AppDispatch) => {
  await ApiService.get(endpointUrls.peopleDetail(id))
    .then((res: IBackendGetGeneric<person>) =>
      handleApiThenGeneric<IBackendGetGeneric<person>, person>({ res, onSuccessData: (data) => dispatch(setUserPerson(data)), notifFail: false, notifSuccess: false })
    )
    .catch(() => {});
};
